<template>
    <div class="ring-diagram">
        <div class="heartbroken"></div>
        <div v-for="(item, index) in pieData" :key="index" :style="`${item.path} z-index: ${index + 1};`"
            :class="`ring ring-${index + 1} ${item.active ? 'active' : ''}`"></div>
    </div>
</template>

<script>
export default {
    props: {
        dataSource: {
            type: Array,
            default: () => { }
        }
    },
    data() {
        return {};
    },
    computed: {
        pieData() {
            if (this.dataSource.length <= 0) return [];
            return this.buildSectorPaths(this.dataSource, 180);
        }
    },
    mounted() { },
    methods: {
        execPoint(cx, cy, r, ratio) {
            // 计算弧度，一个整圆弧度是 2π
            const rad = ratio * 2 * Math.PI;
            return {
                x: cx + Math.sin(rad) * r,
                y: cy - Math.cos(rad) * r
            };
        },
        buildSectorPaths(data, width) {
            // 偏转量
            let offset = 0;
            // 圆心坐标
            const cx = width / 2;
            const cy = width / 2;
            // 半径
            const r = width / 2;
            return data.map(datum => {
                let path = `M ${cx},${cy}`;
                // 圆弧起点
                const start = this.execPoint(cx, cy, r, offset);
                path += ` L ${start.x},${start.y}`;
                // 圆弧终点
                offset += datum.ratio;
                const end = this.execPoint(cx, cy, r, offset);
                // 圆弧大于 π 画大圆，否则画小圆
                const angle = datum.ratio * 2 * Math.PI;
                path += ` A ${r},${r} 0,${angle > Math.PI ? 1 : 0},1 ${end.x},${end.y}`;
                path += ' Z';
                path = `clip-path: path('${path}');`;
                if (datum.ratio == 1) path = '';
                if (datum.ratio == 0) path = 'display: none;';
                datum.path = path;
                return datum;
            });
        }
    }
};
</script>
<style lang="scss">
.ring-diagram {
    width: 200px;
    height: 200px;
    position: relative;

    .heartbroken {
        width: 100px;
        height: 100px;
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 20;

        &::before {
            position: absolute;
            width: 122px;
            height: 122px;
            background-color: rgba(255, 255, 255, 0.2);
            content: '';
            left: -11px;
            top: -11px;
            border-radius: 50%;
        }
    }

    .ring {
        width: 180px;
        height: 180px;
        border-radius: 50%;
        position: absolute;
        top: 10px;
        left: 10px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s ease-in;

        &:hover,
        &.active {
            transform: scale(1.1);
        }
    }

    .ring-1 {
        background: linear-gradient(71deg, rgba(99, 125, 255, 1), rgba(163, 144, 255, 1));
    }

    .ring-2 {
        background: linear-gradient(270deg, #C3CCFF 0%, #D4D1FF 100%);
    }

    .ring-3 {
        background: linear-gradient(270deg, #ffc801 0%, #ffff03 100%);
    }
}
</style>
